import createIcon from '../../createIcon';

/**
 * @component @name MarkChatUnread
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNy45OFYxN0MyMiAxOC4xIDIxLjEgMTkgMjAgMTlINkwyIDIzVjVDMiAzLjkgMi45IDMgNCAzSDE0LjFDMTQuMDQgMy4zMiAxNCAzLjY2IDE0IDRDMTQgNi43NiAxNi4yNCA5IDE5IDlDMjAuMTMgOSAyMS4xNiA4LjYxIDIyIDcuOThaTTE2IDRDMTYgNS42NiAxNy4zNCA3IDE5IDdDMjAuNjYgNyAyMiA1LjY2IDIyIDRDMjIgMi4zNCAyMC42NiAxIDE5IDFDMTcuMzQgMSAxNiAyLjM0IDE2IDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkChatUnread = createIcon('MarkChatUnread', [
  [
    'path',
    {
      d: 'M22 7.98V17C22 18.1 21.1 19 20 19H6L2 23V5C2 3.9 2.9 3 4 3H14.1C14.04 3.32 14 3.66 14 4C14 6.76 16.24 9 19 9C20.13 9 21.16 8.61 22 7.98ZM16 4C16 5.66 17.34 7 19 7C20.66 7 22 5.66 22 4C22 2.34 20.66 1 19 1C17.34 1 16 2.34 16 4Z',
      key: '1taq5d',
    },
  ],
]);

export default MarkChatUnread;
